import { type LngLat } from '@adv-frontend/yandex-maps-kit';

export const DEFAULT_ZOOM = 17;

export const DEFAULT_POINT: { zoom: number; center: LngLat } = {
    zoom: 12,
    center: [37.6156, 55.7522],
};

export const ZOOM: Record<string, number> = {
    house: DEFAULT_ZOOM,
    street: 15,
    metro: DEFAULT_ZOOM,
    default: 10,
};
